import Blue from "~/core";

new Blue({
	name: 'Feature Actions Nav Menu',
	selector: ".feature-actions",
	setup(feature) {
		const dropdown = feature.querySelector('.feature-actions__dropdown');
		const trigger = feature.querySelector('.dropdown__primary-label');

		const closeAllMenus = e => {
			let activeMenus = [...document.querySelectorAll('.is-active')];
			activeMenus.forEach(active => active.classList.remove('is-active'));
		};

		const bindNavEvents = (item, trigger) => {
			if (trigger) {
				this.$addEvents(trigger, 'click.stop.prevent enter.stop.prevent space.stop.prevent', e => {
					if (!item.classList.contains('is-active')) {
						closeAllMenus()
					}
					item.classList.toggle('is-active');
				});
			}
		};


		bindNavEvents(dropdown, trigger);
		this.$addEvents(document, 'click', closeAllMenus);
	}
});
